module.exports = __webpack_public_path__ + "src/assets/img/door_left_color.f9315bcf.svg";